import Swiper, { A11y, Navigation, Pagination, Autoplay, EffectFade, Parallax } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {
    Swiper.use([ A11y, Navigation, Pagination, Autoplay, EffectFade, Parallax ]);

    var alu = document.querySelector('.alu .swiper-container--media');

    // ALU
    if (alu) {
        var nberSlides = document.querySelectorAll('.alu .swiper-container--media .swiper-slide').length; 
        var activeSlide = document.querySelector('.alu-pagination__item--active');
        var totalSlide = document.querySelector('.alu-pagination__item--total');
        var progressBar = document.querySelector('.alu-progress__bar'); 
        var navigationArrows = document.querySelectorAll('.alu-navigation__item');
        var dataSlideAuto = document.querySelector('.alu .swiper-container--media').getAttribute('data-slide_auto');
        var dataSlideSpeed = document.querySelector('.alu .swiper-container--media').getAttribute('data-slide_speed');

        if (totalSlide) {
            totalSlide.innerHTML = nberSlides;
        }

        // Media (image or video) swiper
        var aluConfig = {
            slidesPerView: 1,
            centeredSlides: true,
            speed: 1000,
            loop: true,
            parallax: true,

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
            },

            navigation: {
                prevEl: '.alu-navigation__prev',
                nextEl: '.alu-navigation__next',
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            breakpoints: {
                0 : {
                    grabCursor: true,
                    allowTouchMove: true,
                },
                
                640: {
                    grabCursor: false,
                    allowTouchMove: false,
                }
            }
        };


        if (dataSlideAuto === '1') {
            aluConfig.autoplay = {
                delay: 100000, // Big number so it doesn't interfere with the progress bar function animation
                disableOnInteraction: false,
            }
        }

        // Fractionned progress bar that swiper has
        else {
            aluConfig.pagination = {
                el: '.alu-progress',
                type: 'progressbar',
            }
        }

        var aluMedia = new Swiper('.alu .swiper-container--media', aluConfig);

        // Reset the progress bar animation when the slide is automaticly changing
        aluMedia.on("slideChange", function () {
            void progressBar.offsetWidth;
            progressBar.style.animation = null;

            pagination();
        });

        aluMedia.on("slideChangeTransitionEnd", function () {
            document.querySelector('.alu .swiper-container--content a.swiper-slide-active').addEventListener('click', function () {            
                window.location.href = this.getAttribute('href');
            });
        });



        // Link + title/description swiper
        var aluContent = new Swiper('.alu .swiper-container--content', {
            slidesPerView: 1,
            centeredSlides: true,
            speed: 1000,
            loop: true,
            grabCursor: false,
            allowTouchMove: false,
            parallax: true,
        
            keyboard: {
                enabled: true,
            },
        
            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
            },
        
            navigation: {
                prevEl: '.alu-navigation__prev',
                nextEl: '.alu-navigation__next',
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        });

        // Remove for fix
        // document.querySelector('.alu .swiper-container--content a.swiper-slide-active').addEventListener('click', function () {
        //     window.location.href = this.getAttribute('href');
        // });


        if (progressBar) {
            progressBar.style.animation = "progress 1 linear";
            progressBar.style.animationDuration = +dataSlideSpeed + "s";

            // Retrigger the progress bar animation when it's over
            progressBar.addEventListener("animationend", endProgress);

            // Retrigger the progress bar animation when clicking on arrows
            navigationArrows.forEach(function (arrow) {
                arrow.addEventListener('click', endProgress);
            });
        }
        

        // Retrigger the progress bar animation when the slide is automaticly changing
        function endProgress() {
            aluMedia.slideNext();
            aluContent.slideNext();

            progressBar.style.animation = "progress 1 linear";
            progressBar.style.animationDuration = +dataSlideSpeed +"s";
        }



        // Fraction pagination (can't do it directly w/ Swiper because of the progress bar)
        function pagination() {
            var current = aluMedia.realIndex + 1;

            if (current > nberSlides) {
                current = 1;
            }
            
            var idx = current < 10 ? current : current;

            activeSlide.innerHTML = idx;
        }
    }





    // ACTUALITES
    var ac = document.querySelector('.ac .swiper-container');

    if (ac) {
        var acConfig = {
            grabCursor: true,
            speed: 700,

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
            },

            navigation: {
                prevEl: '.ac-navigation__prev',
                nextEl: '.ac-navigation__next',
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },

                960: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },

                1200: {
                    slidesPerView: 2,
                    spaceBetween: 30
                }
            }
        }

        var acSwiper = new Swiper('.ac .swiper-container', acConfig);
    }



    // AGENDA
    var ag = document.querySelector('.ag .swiper-container');

    if (ag) {
        var agConfig = {
            grabCursor: true,
            speed: 700,

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
            },

            navigation: {
                prevEl: '.ag-navigation__prev',
                nextEl: '.ag-navigation__next',
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },

                640: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },

                1200: {
                    slidesPerView: 2,
                    spaceBetween: 30
                }
            }
        }

        var agSwiper = new Swiper('.ag .swiper-container', agConfig);
    }
}